import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import RefreshableInterface from "../utils/RefreshableInterface";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";

import 'select2';

interface Select2Props {
    options: object
}

@Dce("Select2")
export default class Select2 extends DceComponent<Select2Props> {

    constructor(elem: DceHTMLElement, props: Select2Props) {
        super(elem, props);
        let select = $(elem).select2(this.props.options);
        console.log("SELECT2", select);
    }

    defaultProps(): Partial<Select2Props> {
        return {
            options: {}
        }
    }
}